import {getLocalStorage} from '@/Utils/CommonUtils';
import Loader from '@/Atoms/CCLoader/CCLoader';
import React, {useEffect, useState} from 'react';
import Box from '@/Atoms/Box';
import {Image} from 'react-native';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import Spacer from '@/Atoms/Spacer';
import Ionicons from 'react-native-vector-icons/Ionicons';
import MaterialIcon from 'react-native-vector-icons/MaterialCommunityIcons';
import CCButton from '@/Atoms/CCButton';
import Leaderboard from '../Books/components/Leaderboard';
import useGetBookSummaryApi from '@/Hooks/LMSApi/getBookSummary';
import ENV from '../../../environment';

const LMS = ({isBeginnerPlayer}) => {
  const {isMobileOrTab} = useMediaQuery();
  const [courseList, setcourseList] = useState<any>([]);
  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState<string | null>(null);

  const handleGetSummary = data => {
    setcourseList(data);
  };
  const {mutate: getBookSummary, isLoading} =
    useGetBookSummaryApi(handleGetSummary);

  useEffect(() => {
    getBookSummary();
  }, []);

  useEffect(() => {
    const redirectIfBeginner = async () => {
      if (isBeginnerPlayer) {
        const token = await getLocalStorage('access_token');
        setIframeUrl(
          `${ENV.LMS_URL}/learning/53336ad7-e138-492c-a60d-304a61d1e930?token=${token}&noheader=1&isbeginner=${isBeginnerPlayer}&showIframe=${showIframe}`,
        );
        setShowIframe(true);
      }
    };
    redirectIfBeginner();
  }, [isBeginnerPlayer]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'REDIRECT' && event.data?.url) {
        window.location.href = event.data.url;
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const redirect = async () => {
    const token = await getLocalStorage('access_token');
    setIframeUrl(
      `${ENV.LMS_URL}/?token=${token}&noheader=1&isbeginner=${isBeginnerPlayer}`,
    );
    setShowIframe(true);
  };

  if (showIframe && iframeUrl) {
    return (
      <Box style={{flex: 1}}>
        <iframe
          src={iframeUrl}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none',
            zIndex: 9999,
            pointerEvents: 'auto',
          }}
          allowFullScreen
        />
      </Box>
    );
  }

  return (
    <Box key="lms" style={{flex: 1}}>
      <Box
        type="row-center-space-around"
        style={{backgroundColor: CCColors.Primary.Brown}}>
        <Box flex={0.4}>
          <CCText color={CCColors.Primary.Default} fontSize={FontSizes[14]}>
            Welcome to
          </CCText>
          <CCText
            color={CCColors.White}
            fontSize={FontSizes[isMobileOrTab ? 14 : 28]}>
            CircleChess Academy
          </CCText>
        </Box>
        <Box flex={0.4}>
          <Image
            source={{
              uri: 'https://cc-leagues.s3.ap-south-1.amazonaws.com/lms_banner.png',
            }}
            style={{
              width: '100%',
              height: isMobileOrTab ? 100 : 200,
              resizeMode: 'contain',
              borderRadius: 15,
            }}
          />
        </Box>
      </Box>
      <Spacer spacing={40} />
      {isLoading ? (
        <Loader loading />
      ) : (
        <Box
          margin={20}
          gap={20}
          flexDirection="row"
          alignItems="flex-start"
          flex={1}>
          <Box flex={0.7}>
            {courseList.map(data => (
              <Box
                flexDirection="row"
                alignItems="flex-start"
                gap={30}
                style={{
                  backgroundColor: CCColors.White,
                  shadowColor: 'rgb(77, 63, 55)', // Shadow color
                  shadowOffset: {
                    width: 1, // Horizontal shadow offset
                    height: 3.43, // Vertical shadow offset
                  },
                  shadowOpacity: 0.15, // Shadow transparency
                  shadowRadius: 6.86, // How blurry the shadow is
                  elevation: 4,
                  padding: 10,
                  marginTop: 50,
                }}>
                <Image
                  style={{
                    width: isMobileOrTab ? 100 : 200,
                    height: isMobileOrTab ? 100 : 200,
                    resizeMode: 'cover',
                    borderRadius: 15,
                  }}
                  source="https://cc-leagues.s3.ap-south-1.amazonaws.com/lms_banner.png"
                />
                <Box alignItems="flex-start">
                  <CCText fontSize={FontSizes[28]}>{data?.title}</CCText>
                  <Spacer spacing={20} />
                  <Box
                    flexWrap="wrap"
                    type="row-flex-start"
                    gap={15}
                    style={{width: '70%'}}>
                    <Box type="row-center" gap={5}>
                      <Ionicons
                        name="documents-outline"
                        size={14}
                        color={CCColors.Black}
                      />
                      <CCText>{data?.chapters} Courses</CCText>
                    </Box>
                    <Box type="row-center" gap={5}>
                      <Ionicons
                        name="person-outline"
                        size={14}
                        color={CCColors.Black}
                      />
                      <CCText>{data?.students} Students</CCText>
                    </Box>
                    <Box type="row-center" gap={5}>
                      <Ionicons
                        name="flash-outline"
                        size={14}
                        color={CCColors.Black}
                      />
                      <CCText>{data?.puzzles} Puzzles</CCText>
                    </Box>
                    {data?.videos > 0 && (
                      <Box type="row-center" gap={5}>
                        <Ionicons
                          name="play-circle-outline"
                          size={14}
                          color={CCColors.Black}
                        />
                        <CCText>{data?.videos} Videos</CCText>
                      </Box>
                    )}
                    <Box type="row-center" gap={5}>
                      <MaterialIcon
                        name="format-list-checks"
                        size={14}
                        color={CCColors.Black}
                      />
                      <CCText>{data?.mcq} MCQ</CCText>
                    </Box>
                    <Box type="row-center" gap={5}>
                      <Ionicons
                        name="wallet-outline"
                        size={14}
                        color={CCColors.Black}
                      />
                      <CCText>Earn {data?.total_points} Points</CCText>
                    </Box>
                  </Box>
                  <Box marginTop={20} type="row-flex-start" gap={10}>
                    <Image
                      style={{
                        width: isMobileOrTab ? 30 : 50,
                        height: isMobileOrTab ? 30 : 50,
                        resizeMode: 'cover',
                        borderRadius: 15,
                      }}
                      source="https://cc-leagues.s3.ap-south-1.amazonaws.com/lifetime_access.png"
                    />
                    <Image
                      style={{
                        width: isMobileOrTab ? 30 : 50,
                        height: isMobileOrTab ? 30 : 50,
                        resizeMode: 'cover',
                        borderRadius: 15,
                      }}
                      source="https://cc-leagues.s3.ap-south-1.amazonaws.com/verified_by_circlechess.png"
                    />
                    <CCButton
                      onPress={() => redirect()}
                      titleStyle={{
                        color: CCColors.TextColor.Primary,
                        padding: 8,
                      }}>
                      Explore Now
                    </CCButton>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
          <Box flex={0.3}>
            <Leaderboard
              bookId={1}
              puzzleData={{
                leaderboard: courseList[0]?.leaderboard?.map((l, i) => ({
                  name: l.name,
                  solved_count: l.total_score,
                  rank: i + 1,
                })),
              }}
            />
          </Box>
        </Box>
      )}

      {/* <Loader loading={true} />; */}
    </Box>
  );
};

export default LMS;
